import React, { useRef, useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Button, { PrimaryButton, ButtonGroup } from '../../../core/components/Button';
import customizableComponent from '../../../core/hocs/customization';
import usePost from '../../../social/hooks/usePost';
import useUser from '../../../core/hooks/useUser';
import useSocialMention from '../../../social/hooks/useSocialMention';
import withSDK from '../../../core/hocs/withSDK';
import { info } from '../../../core/components/Confirm';
import { Avatar, CommentComposeBarContainer, CommentComposeBarInput } from './styles';
import { backgroundImage as UserImage } from '../../../icons/User';
import { extractMetadata } from '../../../helpers/utils';
const TOTAL_MENTIONEES_LIMIT = 30;
const COMMENT_LENGTH_LIMIT = 50000;
const CommentComposeBar = ({ className, userToReply, onSubmit, onCancel, currentUserId, postId, }) => {
    const { post } = usePost(postId);
    const { targetId: communityId, targetType: communityType } = post;
    const { file, user } = useUser(currentUserId);
    const { text, markup, mentions, onChange, clearAll, queryMentionees } = useSocialMention({
        targetId: communityId,
        targetType: communityType,
    });
    const { formatMessage } = useIntl();
    const addComment = () => {
        if (text === '')
            return;
        if ((mentions === null || mentions === void 0 ? void 0 : mentions.length) > TOTAL_MENTIONEES_LIMIT) {
            return info({
                title: React.createElement(FormattedMessage, { id: "CommentComposeBar.unableToMention" }),
                content: React.createElement(FormattedMessage, { id: "CommentComposeBar.overMentionees" }),
                okText: React.createElement(FormattedMessage, { id: "CommentComposeBar.okText" }),
            });
        }
        if ((text === null || text === void 0 ? void 0 : text.length) > COMMENT_LENGTH_LIMIT) {
            return info({
                title: React.createElement(FormattedMessage, { id: "CommentComposeBar.unableToPost" }),
                content: React.createElement(FormattedMessage, { id: "CommentComposeBar.overCharacter" }),
                okText: React.createElement(FormattedMessage, { id: "CommentComposeBar.done" }),
            });
        }
        const { metadata, mentionees } = extractMetadata(mentions);
        onSubmit(text, mentionees, metadata);
        clearAll();
    };
    const isEmpty = !text || (text === null || text === void 0 ? void 0 : text.trim().length) === 0;
    const placeholder = userToReply
        ? formatMessage({ id: 'CommentComposeBar.replayTo' }) + userToReply
        : formatMessage({ id: 'CommentComposeBar.saySomething' });
    const submitButtonText = userToReply
        ? formatMessage({ id: 'reply' })
        : formatMessage({ id: 'CommentComposeBar.addComment' });
    const commentInputRef = useRef();
    useEffect(() => {
        commentInputRef.current.focus();
    }, []);
    return (React.createElement(CommentComposeBarContainer, { className: className },
        React.createElement(Avatar, { avatar: file === null || file === void 0 ? void 0 : file.fileUrl, backgroundImage: UserImage, displayName: user.displayName }),
        React.createElement(CommentComposeBarInput, { ref: commentInputRef, "data-qa-anchor": "comment-compose-bar-textarea", placeholder: placeholder, type: "text", value: markup, multiline: true, mentionAllowed: true, queryMentionees: queryMentionees, onChange: onChange }),
        React.createElement(ButtonGroup, { isFullWidth: true },
            React.createElement(Button, { variant: "outline", onClick: onCancel, "data-qa-anchor": "comment-compose-bar-cancel-button" },
                React.createElement(FormattedMessage, { id: "cancel" })),
            React.createElement(PrimaryButton, { isDisabled: isEmpty, onClick: addComment, colorScheme: "primary", "data-qa-anchor": userToReply
                    ? 'comment-compose-bar-reply-button'
                    : 'comment-compose-bar-add-comment-button' }, submitButtonText))));
};
export default withSDK(customizableComponent('CommentComposeBar', CommentComposeBar));
//# sourceMappingURL=index.js.map